(function() {

	var $header = null;

	$(document).ready(function() {
		$header = $(".page-header");
	});

	$(window).on("load scroll resize orientationchange", function() {
		if (!$header) {
			return;
		}

		var scroll = $(window).scrollTop();
		var height = window.innerHeight;
		var bound = scroll + (height * 4.0 / 5.0);

		// Fix/release header
		if (70 < scroll) {
			$header.addClass("fixed");
		}
		else {
			$header.removeClass("fixed");
		}

	});


})();